(function () {
	'use strict';

	angular.module('qbePortal').directive('qbSimpleSelectArrowClick',
		function () {
			return {
				restrict: 'A',
				link: function (scope, elm, attrs, ctrl) {
					var $select = $(elm).find('select');

					var openSelect = function (element) {
						var worked = false;
						if (document.createEvent) { // all browsers
							var e = document.createEvent("MouseEvents");
							e.initMouseEvent("mousedown", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
							worked = element.dispatchEvent(e);
						} else if (element.fireEvent) { // ie
							worked = element.fireEvent("onmousedown");
						}
					}

					$(elm).click(function (event) {
						openSelect($select.get(0));
					});
				}
			};
		});
})();
